import React from 'react';
import config from '../../config';
import { twitterPageURL } from '../../util/urlHelpers';
import { StaticPage, TopbarContainer } from '../../containers';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  ExternalLink,
} from '../../components';

import css from './FaqPage.module.css';
import image from '../../assets/background-1440.jpg';

const FaqPage = () => {
  const { siteTwitterHandle, siteFacebookPage } = config;
  const siteTwitterPage = twitterPageURL(siteTwitterHandle);

  // prettier-ignore
  return (
    <StaticPage
      title="FAQ"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'FaqPage',
        description: 'FAQ | Webuku',
        name: 'FAQ',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.staticPageWrapper}>
          <h1 className={css.pageTitle}>FAQ</h1>

          <div className={css.mainContent}>
              <h2>What is Buku ?</h2>

              <p>Buku is building the #1 community of experiences for water lovers, by water lovers. We are a Maryland Based company, launched right on the Chesapeake Bay, which is home to over 400,000 boats. We are proud to say that people have been enjoying our local waterways with family and friends for centuries.</p>
          
              <h2>Where are the boats located ?</h2>
              <p>Although most of our boats reside in the Baltimore Harbor, we do have boats available in other parts of the Chesapeake bay and beyond. Found a boat you like? Check the boat’s availability, book it, and make a secure payment right away - at which point we will look forward to SEAing you on the water.</p>
         
              <h2>What should I do after I make a boat rental ?</h2>
              <p>The day of your booking, you will receive instructions on how (via your best way of contact) to get to your boat site. When you reach the boat site, be prepared to provide identification verification (Driver’s license, State ID, Passport, etc) - if you plan to enjoy a bottle or wine or spirit during your trip, we want to ensure that everyone is of drinking age. Once we complete a brief, thorough orientation on boat safety, get ready to board and enjoy your curated water experience.</p>
          </div>
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

export default FaqPage;
